import {SportsDomainService} from "../../../domain/sports/domain-services/sports.domain-service";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {SportDomainModel} from "../../../domain/sports/models/sport-domain-model";
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import type {NewSearchWidgetController} from "../new-search-widget.controller";
import type {NewSearchWidgetState} from "../models/new-search-widget.state";
import {SPORT_TYPES} from "../../../core/app/consts";

export class NewSearchWidgetSportTypesFetchHandler extends ActionHandler {
  controller: NewSearchWidgetController;
  state: NewSearchWidgetState;
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.FETCH.onSportTypesFetch;

  static injectables = [SportsDomainService];

  constructor(sportsDomainService: SportsDomainService) {
    super();

    this.sportsDomainService = sportsDomainService;
  }

  onLoaded() {
    this.state.selectedSportId = NEW_SEARCH_WIDGET.allSportsId;
  }

  async action() {
    const sports: SportDomainModel[] = this.sportsDomainService.sports.filter(sport => !sport.hide && sport.id !== SPORT_TYPES.onTv);

    const allSports: SportDomainModel = new SportDomainModel({
      id: NEW_SEARCH_WIDGET.allSportsId,
      name: this.controller.terms.WEB_ALL_SPORTS
    }, -1);

    sports?.push(allSports);

    this.state.sports = sports;
  }
}
